module.exports = __webpack_public_path__ + "static/app-animation-1d6e8db387914850664f75910bf241da.mp4";